export default __webpack_public_path__ + "static/media/Rare Relic.29ae65cc.jpg";